function MenuAula6() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#CSS-Module">CSS Module</a></li>
              <li><a href="#Exemplo-1-prático-de-CSS-Module">Exemplo 1, prático de CSS Module</a></li>
              <li><a href="#Exemplo-2-prático-de-CSS-Module">Exemplo 2 prático de CSS Module</a></li>
              <li><a href="#CSS-Módulo-ou-Styled-Components">CSS Módulo ou Styled-Components</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula6;